export function authHeader() {
  return {};
}
export function golangHeader() {
  return {
    "Content-Type": "application/json",
  };
}

